import { createContext, useContext } from 'react';

import type { PlatformEdition } from 'src/types/platform-feature';
import { DEFAULT_PLATFORM_EDITION } from 'src/utils/platform-features';

/**
 * The active platform's edition, resolved once for the whole tree. Outside the provider
 * (auth pages, early loading screens) it is the default edition, so reading it is always safe.
 */
export const PlatformEditionContext = createContext<PlatformEdition>(DEFAULT_PLATFORM_EDITION);

export const usePlatformEdition = (): PlatformEdition => useContext(PlatformEditionContext);
